module.exports = __webpack_public_path__ + "img/img5.4a7030cb.png";